import { clientSideMetrics } from '@marketplace-web/shared/metrics'

const ITEM_PAGE_BUY_BUTTON_TOTAL_METRIC_NAME = 'frontend_item_buy_button_total'

export const incrementItemPageBuyButtonShowCounter = (available: 'true' | 'false') => {
  clientSideMetrics.counter(ITEM_PAGE_BUY_BUTTON_TOTAL_METRIC_NAME, { available }).increment()
}
